import { BaseModel } from "./BaseModel";
import { HighwayProps } from "./types";

export class Highway extends BaseModel<HighwayProps> {
	id: string;
	name: string;
	code: string;
	jurisdiction: string;

	constructor(data: HighwayProps) {
		super(data);
		this.id = data.id;
		this.name = data.name;
		this.code = data.code;
		this.jurisdiction = data.jurisdiction;
	}

	get fullName() {
		return `${this.name} (${this.code})`;
	}
}
